import { render, staticRenderFns } from "./UserMiddlemansTable.vue?vue&type=template&id=d1ab6bf6&"
import script from "./UserMiddlemansTable.vue?vue&type=script&lang=ts&"
export * from "./UserMiddlemansTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports